import CardForm from 'refactored/features/soForm/steps/card/creditCard/Form/components/CardForm/styled';

export default CardForm;
